import React, { Component } from 'react'
import MailchimpSubscribe from 'react-mailchimp-subscribe'
import styles from './Subscribe.module.css'

const url =
  'https://biglifemanagement.us16.list-manage.com/subscribe/post?u=936a6340689a9abbf0872f45e&amp;id=bb9e49e7f7'

class Subscribe extends Component {
  render() {
    return (
      <div className={styles.Subscribe}>
        <h4>Join Mailing List</h4>
        <MailchimpSubscribe url={url} />
      </div>
    )
  }
}

export default Subscribe



// WEBPACK FOOTER //
// ./src/components/Navigation/Subscribe/Subscribe.js